import { AuthProvider, SignInWhatsappPage } from '@hub-la/fe-auth'

export const SignInWhatsappInit = () => {
  return (
    <AuthProvider>
      <SignInWhatsappPage />
    </AuthProvider>
  )
}
